import { FAQ } from '~/components/FAQ/FAQ'
import { FAQcontent } from '~/components/FAQ/FAQcontent'

export default function FaqPage() {
  return <FAQ content={FAQcontent} />
}